import { render, staticRenderFns } from "./add.vue?vue&type=template&id=f9c8d050&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=f9c8d050&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../.yarn/__virtual__/vue-loader-virtual-45869d479f/4/.yarn/berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c8d050",
  null
  
)

export default component.exports